import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.26563 0.433594C4.12359 0.433594 0.765625 3.79177 0.765625 7.9336C0.765625 12.0756 4.12366 15.4336 8.26563 15.4336C12.4076 15.4336 15.7656 12.0756 15.7656 7.9336C15.7656 3.79163 12.4076 0.433594 8.26563 0.433594ZM12.3158 8.50931H8.84134V11.9838C8.84134 12.3017 8.58365 12.5595 8.26559 12.5595C7.94767 12.5595 7.68985 12.3019 7.68985 11.9838V8.50931H4.21536C3.89745 8.50931 3.63962 8.25162 3.63962 7.93356C3.63962 7.61564 3.8973 7.35782 4.21536 7.35782H7.68985V3.88333C7.68985 3.56541 7.94753 3.30759 8.26559 3.30759C8.58351 3.30759 8.84134 3.56527 8.84134 3.88333V7.35782H12.3158C12.6337 7.35782 12.8916 7.6155 12.8916 7.93356C12.8916 8.25148 12.634 8.50931 12.3158 8.50931Z"
            fill="white"
        />
    </svg>
);
export default SVGComponent;